<template>
  <a-radio-button :class="bem.b()" v-bind="attrs">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-radio-button>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
// import { RadioButton } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
defineOptions({ name: 'LlRadioButton' })
const attrs = useAttrs()
const bem = createNamespace('radio-button')
</script>
